<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			titulo="Cancelar Ata"
			nome-botao-confirmar="Salvar"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:max-width="610"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmar"
			:is-confirmar-desabilitado="!formIsValid || salvando"
			@close="fecharModal"
		>
			<template #body>
				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<v-alert class="text-body-3" dense icon="mdi-alert-circle-outline" type="warning" text>
							Após salvar, a ata será cancelada e a ação não poderá ser desfeita.
						</v-alert>
						<label-personalizado
							nome-campo="Motivo"
							obrigatorio-por-padrao
							class="mb-2"
						></label-personalizado>
						<v-textarea
							v-model.trim="motivo"
							placeholder="Informe o motivo"
							:rules="regras"
							rows="1"
							no-resize
							auto-grow
							counter="1000"
							class="ma-0 py-0"
						></v-textarea>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { mapGetters, mapState } from 'vuex'

export default {
	name: 'modal-cancelar-ata',
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			motivo: '',
			formIsValid: true,
			salvando: false,
			regras: [
				(value) => this.regraObrigatoriedade(value, 'O motivo é obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						1000,
						'O campo de motivo deve ser igual ou menor que 1000 caracteres!',
					),
			],
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
		...mapGetters({
			cabecalho: getterTypes.ATA.GET_ATA_PARA_CABECALHO,
		}),
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		async confirmar() {
			if (this.$refs.form.validate()) {
				this.salvando = true
				await this.$store
					.dispatch(actionTypes.ATA.CANCELAR_ATA, {
						idAta: this.informacoesAta.id,
						motivo: this.motivo,
					})
					.then(async () => {
						await this.atualizarInformacoesAta()
						this.mostrarNotificacaoSucessoDefault()
						this.fecharModal()
					})
					.finally(() => (this.salvando = false))
			}
		},
		async atualizarInformacoesAta() {
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.informacoesAta.id)
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, this.cabecalho)
		},
	},
}
</script>
